import { HttpClient } from 'api/http-client';

export interface GroupUser {
  userId: number;
  identityType: string;
}

export interface Groups {
  groupId: number;
  groupName: string;
  users: GroupUser[];
  userCount: number;
}

export interface GroupUsers {
  userId: number;
  emailId: string;
  member: boolean;
}

export interface GroupDetailResponse {
  groupName: string;
  users: GroupUsers[];
}

export interface CreateGroupPayload {
  groupName: string;
  users: {
    emailId: string;
  }[];
}

export interface CreateGroupResponse {
  groupId: number;
  groupName: string;
  users: GroupUser[];
  userCount: number;
}

export interface DeactivateGroupPayload {
  groupId: number;
}

export interface UpdateGroupPayload {
  groupId: number;
  data: {
    groupName?: string;
    users?: { emailId: string }[];
  };
}

export interface DeleteMemberInGroupPayload {
  groupId: number;
  data: { users: { emailId: string }[] };
}

const BASE_URL = '/user-groups';

class GroupsApiClient extends HttpClient {
  public getGroups = async (): Promise<Groups[]> => this.get(`${BASE_URL}`);

  public getGroupsByUser = async (userId: number): Promise<Groups[]> =>
    this.get(`${BASE_URL}/users/${userId}`);

  public getGroupDetail = async (
    groupId: number,
  ): Promise<GroupDetailResponse> => this.get(`${BASE_URL}/${groupId}`);

  public createGroup = async (
    data: CreateGroupPayload,
  ): Promise<CreateGroupResponse> => this.post(`${BASE_URL}`, data);

  public deactivateGroup = async (
    payload: DeactivateGroupPayload,
  ): Promise<Groups[]> => this.delete(`${BASE_URL}/${payload.groupId}`);

  public updateGroup = async (payload: UpdateGroupPayload): Promise<Groups> =>
    this.put(`${BASE_URL}/${payload.groupId}`, { ...payload.data });

  public deleteMemberInGroup = async (
    payload: DeleteMemberInGroupPayload,
  ): Promise<void> =>
    this.put(`${BASE_URL}/${payload.groupId}/delete-group-member`, {
      ...payload.data,
    });
}

export const GroupsApi = new GroupsApiClient();
